
export class Catalogo {
    Codice: number;
    Nome: string;
    Descrizione: string;
    Datavalidodal: Date;
    Datavalidoal: Date;
    Categoria: string;
    Codicefornitore: number;

  constructor(){
    this.Codice=0;
    this.Nome='';
    this.Descrizione='';
    this.Datavalidodal=new Date();
    this.Datavalidoal=new Date();
    this.Categoria='';
    this.Codicefornitore=0;
  }
}
